module.exports = __webpack_public_path__ + "img/u130.b5567bf0.jpg";